fx.ns("shared.screens", class CoverAlbum extends shared.screens.BaseChoiceScreen 
    {    
        constructor()
        {
            super();
    
            this.showNext = false;
            this.showBack = fx.get("mode") == "creating";

            this.styleChoice = "circle";

            this.containerHeight = 450;

            this.title = fx.text("Choisissez la couverture de votre album");
        }

        get currentCover()
        {
            return (fx.get("mode") == "creating") ? this.data.choosedCover : this.data.creation.optionid;
        }
        
        create()
        {
            super.create();
    
            if (this.data.creation.coverChoices.length == 0)
            {
                this.loading(true, fx.text("Chargement"));
                this.data.creation.coverChoices.load();
            }
            else
                this.build();
        }
    
        onDataEvent(event)
        {
            if (event.type == "cover-option-loaded")
                this.build();
        }
    
        build() 
        {    
            super.build();
            
            let options = this.data.choosedSize ? this.data.creation.availableCoverChoicesForShapeSize( this.data.choosedShape, this.data.choosedSize ) : this.data.creation.availableCoverChoices(fx.get("mode") == "creating" ? this.data.choosedFormat : this.data.creation.formatid);
            options = options.sort((a, b) => a.option_id - b.option_id);
    
            if (fx.get("mode") != "creating") // show available first
                options = options.sort( (a, b) => ((this.data.creation.numberPages >= a.min_pages && this.data.creation.numberPages <= a.max_pages) ? 0 : 1) - ((this.data.creation.numberPages >= b.min_pages && this.data.creation.numberPages <= b.max_pages) ? 0 : 1) )
            
            for(let i = 0; i < options.length; i++)
            {
                let option = options.getItemAt(i);
                
                if (option.cover.editor_code == "layflat")
                    continue;
    
                let choice = new shared.components.ProductChoice("circle", option, this.data.creation.getOptionAsset(option), option.cover.shortname, fx.text("De $ à $ pages", option.min_pages,  option.max_pages), fx.text(  "A partir de <strong>$</strong>", this.data.creation.calculatePrice(option)));
                if (this.currentCover == option.option_id)
                    choice.addClass("selected");
    
                this.addChoice(choice, fx.browser.isDesktop ? {width: 190, height : 350} : {width: 190, height : 350, left : "center"})
            }
                
            this.loading(false);
        }
    
    
        onChoiceClicked(coverObj)
        {
            let cover = coverObj.cover.editor_code;
			
            if (cover == "hard")
            {
                if (fx.get("mode") == "creating")
                    this.data.event("next-step")
                else
                    this.trigger("next-step");
            }
            else
            {
                if (fx.get("mode") == "creating")
                {
                    this.data.choosedCover = cover;
                    this.data.event("step-Splash");
                }
                else
                {
                    this.data.book.updateCover(coverObj);
                    this.trigger("reset-navigation");
                }
            }  
        }
    
    });